import { z } from 'zod';

export const companySchema = z.object({
  company_name: z.string(),
  exchange: z.string(),
  ticker: z.string(),
  reported: z.boolean(),
  reporting_date: z.string().datetime(),
  fiscal_period: z.enum(['Q1', 'Q2', 'Q3', 'Q4', 'FY', 'H1', 'H2']),
  fiscal_year: z.number(),
  logo_urls: z.object({
    svg_light: z.string(),
    svg_dark: z.string(),
    png_light: z.string(),
    png_dark: z.string(),
  }),
  surprise_percentage: z.number().optional(),
});

export const searchSchema = z.array(companySchema);
export type Company = z.infer<typeof companySchema>;

// Frontend only
export type CompanyWithReportingLabel = z.infer<
  typeof companyWithReportingLabelSchema
>;
export const companyWithReportingLabelSchema = companySchema.extend({
  reporting_label: z.string(),
});
